import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { Grid } from "semantic-ui-react";
import {
  Heading2,
  Heading5,
} from "../../../components/value-cssmodules/TextComponent";

type Props = {
  items: number;
  text: string | ReactElement;
};

const TableTitle: React.FC<Props> = ({ items, text }) => {
  return (
    <Grid padded={"vertically"}>
      <Grid.Row columns="2" verticalAlign={"middle"}>
        <Grid.Column computer={8} mobile={10} tablet={10}>
          <Heading2>{text}</Heading2>
        </Grid.Column>
        <Grid.Column computer={8} mobile={6} tablet={6}>
          <Heading5>
            {items}{" "}
            <FormattedMessage
              id={"cart.patterns"}
              defaultMessage={"patterns"}
            />
          </Heading5>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default TableTitle;
